"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardTipologia = CardTipologia;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _style = _interopRequireDefault(require("./style"));

var _material = require("@mui/material");

var _iconsMaterial = require("@mui/icons-material");

var _styles = require("@mui/styles");

var _react2 = require("@emotion/react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CardTipologia(props) {
  const {
    id,
    titulo,
    capacidad,
    dormitorios,
    banios,
    unidades,
    openModal,
    eliminarTipologia
  } = props;
  const theme = (0, _styles.useTheme)();
  const classes = (0, _style.default)(theme);

  const [anchorEl, setAnchorEl] = _react.default.useState(null);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (idSelected = null, accion = null) => {
    setAnchorEl(null);

    if (accion == 'editar') {
      openModal(true, idSelected);
    } else if (accion == 'eliminar') {
      eliminarTipologia(idSelected);
    }
  };

  return (0, _react2.jsx)(_material.Card, null, (0, _react2.jsx)(_material.CardHeader, {
    action: (0, _react2.jsx)(_material.IconButton, {
      css: classes.itemAccion,
      "aria-label": "settings",
      onClick: handleClick
    }, (0, _react2.jsx)(_iconsMaterial.MoreVert, null)),
    title: titulo,
    css: classes.titulo
  }), (0, _react2.jsx)(_material.CardContent, null, (0, _react2.jsx)("div", {
    css: classes.item
  }, (0, _react2.jsx)("div", {
    css: classes.itemIcon
  }, (0, _react2.jsx)(_iconsMaterial.PersonOutlineOutlined, null)), (0, _react2.jsx)("div", {
    css: classes.itemTexto
  }, (0, _react2.jsx)(_material.Typography, {
    variant: "body2"
  }, "Capacidad: ", capacidad, "pax"))), (0, _react2.jsx)("div", {
    css: classes.item
  }, (0, _react2.jsx)("div", {
    css: classes.itemIcon
  }, (0, _react2.jsx)(_iconsMaterial.HotelOutlined, null)), (0, _react2.jsx)("div", {
    css: classes.itemTexto
  }, (0, _react2.jsx)(_material.Typography, {
    variant: "body2"
  }, "Dormitorios: ", dormitorios))), (0, _react2.jsx)("div", {
    css: classes.item
  }, (0, _react2.jsx)("div", {
    css: classes.itemIcon
  }, (0, _react2.jsx)(_iconsMaterial.BathtubOutlined, null)), (0, _react2.jsx)("div", {
    css: classes.itemTexto
  }, (0, _react2.jsx)(_material.Typography, {
    variant: "body2"
  }, "Ba\xF1os: ", banios))), (0, _react2.jsx)("div", {
    css: classes.item
  }, (0, _react2.jsx)("div", {
    css: classes.itemIcon
  }, (0, _react2.jsx)(_iconsMaterial.HomeOutlined, null)), (0, _react2.jsx)("div", {
    css: classes.itemTexto
  }, (0, _react2.jsx)(_material.Typography, {
    variant: "body2"
  }, "Cantidad Unidades Iguales: ", unidades.length ? unidades.length : 0)))), (0, _react2.jsx)(_material.Menu, {
    id: "menu-tipologia",
    anchorEl: anchorEl,
    keepMounted: true,
    open: Boolean(anchorEl),
    onClose: handleClose
  }, (0, _react2.jsx)(_material.MenuItem, {
    onClick: () => handleClose(id, 'editar')
  }, "Editar"), (0, _react2.jsx)(_material.MenuItem, {
    onClick: () => handleClose(id, 'eliminar')
  }, "Eliminar")));
}

var _default = CardTipologia;
exports.default = _default;